import Swal from "sweetalert2";
import api from "../../../../utilidades/interceptor";

const apiKey = process.env.REACT_APP_API_KEY


export const getNombres = (setState) => {
    api.get(`${apiKey}/administracion/visitas/getoperador`).then((res) => {
        console.log("ressss ", res.data);
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getUnidad = (setState) => {
    api.get(`${apiKey}/administracion/visitas/getunidad`).then((res) => {
        console.log("res unidad", res.data);
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getAreas = (setState) => {
    api.get(`${apiKey}/administracion/visitas/getareas`).then((res) => {
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}
export const getMotivos = (setState, area) => {
    api.get(`${apiKey}/administracion/visitas/getmotivo?id=${area}`).then((res) => {
        setState(res.data)
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const subirInformacion = (json, inputList, setInputList) => {
    api.post(`${apiKey}/administracion/visitas/registrar`, json).then((res) => {
        setInputList({
            nombreOperador: { value: null, validationType: "empty" },
            unidad: { value: null, validationType: "empty" },
            area: { value: null, validationType: "empty" },
            motivos: { value: null, validationType: "empty" },
            comentarios: { value: null, validationType: "optional" },
        })
        Swal.fire({
            icon: "success",
            title: "Registrado correctamente",
            showConfirmButton: false,
            timer: 1500
        });
        setTimeout(function() {
            document.getElementById("botonRegistrar").disabled = false
        }, 1500);
    })
}
